import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet';
import { useHistory, useParams } from 'react-router-dom';
import avator from '../assets/images/img_avatar3.png'
import pddlogo from '../assets/images/pddlogo.png'
import Swal from 'sweetalert2'
import { GetCustomerName } from './ReservationWebApi';



import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    NavLink
} from "react-router-dom";
export const ReservationDaySelect = () => {

    const { BeneficiaryCode, BeneficiaryName } = useParams();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const history = useHistory();
    const [customerName, setCustomerName] = useState('');

    useEffect(async () => {
        console.log('useeffect')
        getbeneficiaryDate();

        const result = await GetCustomerName()

        if (result.length = 1) {
            setCustomerName(result[0].ConfigValue);
        }

    }, [])

    const getbeneficiaryDate = () => {
        setLoading(true);
        const apiUrl = window.BASE_URL + "/api/pdd/ReservationListBeneficiaryByDate?BeneficiaryCode=" + BeneficiaryCode;
        fetch(apiUrl)
            .then(response => response.json())
            .then((data) => {
                setData(data);
                setLoading(false);
            },
                (error) => {
                    setLoading(false);
                    Swal.fire(
                        'خطا',
                        'خطا سرور ' + error,
                        'error'
                    );
                })
    }

    const SelectDate = (Code, BeneficiaryCode, BeneficiaryName, BeneficiaryDate) => {
        localStorage.setItem('SelectBeneficiaryDate', BeneficiaryDate);
        history.push('/ReservationTimeSelect/' + Code + '/' + BeneficiaryCode + '/' + BeneficiaryName);
    }
    return (
        <>
            <Helmet>
                <title>تاريخ جهت پزشك {BeneficiaryName}</title>
            </Helmet>
            <div>
                {/* Navigation */}
                <div className="nav bg-primary fixed-top pt-2 pb-2">
                    <div className="container">
                        <div className="row">
                            <div className="col-1 pl-0 pr-0" >
                                <img src={pddlogo} alt="" ></img>
                            </div>
                            <div className="col-6 pl-0 pr-0 pt-2">
                                <NavLink to="/" className="header-font mt-0 mb-0 ml-0 mr-1 pl-0 pr-0 text-white d-flex justify-content-start" >نوبت دهي طب پرداز ({process.env.REACT_APP_VERSION})</NavLink>
                            </div>
                            <div className="col-5 pl-0 pr-0 pt-2">
                                <NavLink to="/" className="header-font mt-0 mb-0 ml-4 mr-3 pl-0 pr-0 text-white  d-flex justify-content-end" >{customerName}</NavLink>
                            </div>
                        </div>
                    </div>
                </div>                {/* Page Content */}
                <div className="container">
                    {/* Jumbotron Header */}
                    <header className="bg-info my-4 pt-5 pb-1">
                        <h2 className="display-6">نوبت دهي دكتر {BeneficiaryName}</h2>
                        <p className="lead">پس از انتخاب تاريخ مورد نظر جهت انتخاب زمان نوبت دهي به صفحه بعد راهنمايي خواهيد شد</p>
                        <button class="btn btn-primary" onClick={() => history.goBack()} >صفحه قبل</button>
                    </header>
                    {/* Page Features */}

                    {
                        loading ?
                            <button className="btn btn-primary" type="button" disabled>
                                <span className="spinner-border spinner-border-m" role="status" aria-hidden="true" />در حال بارگذاري ....
                            </button>
                            :
                            <div></div>
                    }


                    <div className="row text-center">
                        {data.map((itm, index) =>
                            (
                                <div className="col-lg-3 col-md-6 mb-4">
                                    <div className="card h-100">
                                        <div className="card-body">
                                            <h6>{itm.BeneficiaryDate} </h6>
                                            <h6 className="text-primary">از ساعت {itm.FromTime} تا  {itm.ToTime}</h6>
                                            <p className="card-text">تعداد ويزيت {itm.VisitCount}</p>
                                            <p className="card-text visit-remain-text-color"> نوبت باقيمانده {itm.VisitRemain}</p>
                                        </div>
                                        <div className="card-footer bg-doctor-footer">
                                            <button className="btn btn-bg-color " onClick={() => SelectDate(itm.Code, itm.BeneficiaryCode, itm.BeneficiaryName, itm.BeneficiaryDate)} >انتخاب روز</button>
                                        </div>
                                    </div>
                                </div>

                            ))
                        }
                    </div>
                    {/* /.row */}
                </div>
                {/* /.container */}
                {/* Footer */}

            </div>
            <nav className="navbar2 fixed-bottom navbar-light footer-font align-items-center align-self-center">
                <a className="mt-3 footer-font" href="http://www.pdd.ir">كليه حقوق متعلق به شركت طراح داده پيشرو مي باشد - www.pdd.ir</a>
            </nav>

        </>
    )
}
